// Fragment "stripe connectivity" — fusionné dans ./index.js.
// Convention : clés plates pointées, valeurs dans les 3 langues, jamais vides.
export default {
  fr: {
    // PaymentProvidersEditor.jsx — la carte Stripe ne stocke plus de clés ici
    "pp.stripeManagedInIntegrations":
      "Les clés Stripe sont gérées dans l'éditeur d'intégrations (Réglages → Intégrations). Ce formulaire n'alimentait aucun paiement.",
    "pp.openIntegrations": "Ouvrir les intégrations",
  },
  en: {
    "pp.stripeManagedInIntegrations":
      "Stripe keys are managed in the Integrations editor (Settings → Integrations). This form never fed any payment path.",
    "pp.openIntegrations": "Open integrations",
  },
  es: {
    "pp.stripeManagedInIntegrations":
      "Las claves de Stripe se gestionan en el editor de integraciones (Ajustes → Integraciones). Este formulario no alimentaba ningún pago.",
    "pp.openIntegrations": "Abrir integraciones",
  },
};
